/* eslint-disable import/no-anonymous-default-export */

export default {
    maptiler: {
        url: "https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=PSC1Aqdp9CIPw6fWJSgB",
    }
}